import { useStore } from '@kundinos/nanostores/react';

import { changeableParametersStore } from './stores';

function useChangeableParameters() {
  return useStore(changeableParametersStore);
}

export default useChangeableParameters;
